import type { LetterTemplate } from "../../types";

export const DISPUTE_ACCOUNT_TYPES = ["Collection", "Late Payment", "Charge-off", "Inquiry", "Other"] as const;
export const DISPUTE_STATUSES = ["In Dispute", "Awaiting Response", "Updated", "Deleted/Resolved"] as const;
export const LETTER_BUREAU_TARGETS = ["Equifax", "Experian", "TransUnion", "Creditor / Furnisher"] as const;

export const FALLBACK_LETTER_TEMPLATES: LetterTemplate[] = [
  { typeKey: "Validation", name: "Validation", description: "", guidance: "" },
  { typeKey: "Investigation", name: "Investigation", description: "", guidance: "" },
  { typeKey: "Goodwill", name: "Goodwill", description: "", guidance: "" },
  { typeKey: "Other", name: "Other", description: "", guidance: "" },
];

export const modalInputClass =
  "mt-1 w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100 outline-none ring-blue-500/40 focus:ring-2";
export const modalCardClass =
  "rounded-xl border border-slate-800 bg-slate-900/95 p-4 shadow-lg shadow-black/20 sm:p-6";

export function isoToDatetimeLocalValue(iso: string | null | undefined): string {
  if (!iso?.trim()) {
    return "";
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return "";
  }
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function datetimeLocalValueToIso(local: string): string | null {
  if (!local.trim()) {
    return null;
  }
  const d = new Date(local);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
